import * as React from "react";
import styled from "react-emotion";
import embed from "embed-video";
import { withContentRect } from "react-measure";

import { theme, mqMin } from "../../styles/theme";
import { toHtml } from "../../utilities";

const Wrap = styled.div`
  max-width: 42rem;
  margin-bottom: ${theme.space3};
  margin-left: auto;
  margin-right: auto;
  text-align: center;
`;

const ArticleVideo = withContentRect(
  "bounds"
)(({ slice, measureRef, measure, contentRect }) => {
  const { width } = contentRect.bounds;
  return (
    <Wrap
      innerRef={measureRef}
      width={width}
      dangerouslySetInnerHTML={{
        __html: embed(slice.primary.share_link, {
          attr: {
            width: width,
            height: width / 16 * 9
          }
        })
      }}
    />
  );
});

export default ArticleVideo;



// WEBPACK FOOTER //
// ./src/components/ArticleVideo/index.js